import updateEntity from 'reducers/updateEntity'
import chooseNextProperId from 'helpers/chooseNextProperId'
import wireDefaults from 'helpers/wires/defaults'
import { ACCESS_REVERSE_MAP } from 'helpers/globals'

export default function changeDoorControllerModel(state, action) {
  const { id, model, limitsExceeded } = action

  if (!limitsExceeded) return updateEntity(state, { id, updates: { model }, entityType: 'doorControllers' })

  const { entities, entities: { doorControllers, doors, wires } } = state
  const doorController = doorControllers.byId[id]

  if (!doorController) return state

  const doorsById = { ...doors.byId }
  const doorIdsToRemove = doorController.doorIds.slice(model.limits.doors)
  const wiresById = { ...wires.byId }
  let newWireIds = [ ...wires.allIds ]
  let wireIdsToRemove = []

  doorIdsToRemove.forEach(doorId => {
    delete doorsById[doorId]

    const wire = Object.values(wiresById).find(wire => wire.start.type === 'door' && wire.start.id === doorId)
    if (wire) {
      delete wiresById[wire.id]
      wireIdsToRemove.push(wire.id)
    }
  })

  const newPeripherals = {}
  Object.entries(ACCESS_REVERSE_MAP).forEach(([limitType, peripheralTypes]) => {
    peripheralTypes.forEach(peripheralType => {
      newPeripherals[peripheralType] = {
        allIds: [ ...entities[peripheralType].allIds ],
        byId: { ...entities[peripheralType].byId }
      }
    })

    let count = 0
    doorController.doorIds.forEach((doorId, index) => {
      const door = doors.byId[doorId]

      peripheralTypes.forEach(peripheralType => {
        if (index > model.limits.doors - 1) {
          door[peripheralType].forEach(peripheralId => delete newPeripherals[peripheralType].byId[peripheralId])
          newPeripherals[peripheralType].allIds = newPeripherals[peripheralType].allIds.filter(peripheralId => !door[peripheralType].includes(peripheralId))
        } else {
          door[peripheralType].forEach(peripheralId => {
            if (++count > model.limits[limitType]) {
              delete newPeripherals[peripheralType].byId[peripheralId]
              newPeripherals[peripheralType].allIds = newPeripherals[peripheralType].allIds.filter(currentId => currentId !== peripheralId)
              doorsById[doorId][peripheralType] = doorsById[doorId][peripheralType].filter(currentId => currentId !== peripheralId)
            }
          })
        }
      })
    })
  })

  // handle expansion controller model connection type changes
  // note: this check may need to be updated if we add more than two connection types
  if (doorController.isExpansion && model.connection !== doorController.model.connection) {
    const wire = Object.values(wiresById).find(wire => wire.start.type === 'doorController' && wire.start.id === doorController.id)

    if (wire) {
      delete wiresById[wire.id]
      wireIdsToRemove.push(wire.id)
    }

    // add a new wire for non-Ethernet case
    const parentController = doorControllers.byId[doorController.parentId]

    if (model.connection !== 'Ethernet' && parentController) {
      const wireId = chooseNextProperId(wires.allIds)

      const newWire = Object.assign({}, wireDefaults, {
        location: [location, parentController.location],
        strokeColor: doorController.color,
        start: { id, type: 'doorController' },
        end: { id: doorController.parentId, type: 'doorController' },
        id: wireId
      })

      wiresById[wireId] = newWire
      newWireIds = newWireIds.concat(wireId)
    }
  }

  return Object.assign({}, state, {
    entities: {
      ...entities,
      doorControllers: {
        byId: {
          ...doorControllers.byId,
          [id]: {
            ...doorController,
            model,
            doorIds: doorController.doorIds.slice(0, model.limits.doors)
          }
        },
        allIds: doorControllers.allIds
      },
      doors: {
        byId: doorsById,
        allIds: doors.allIds.filter(doorId => !doorIdsToRemove.includes(doorId))
      },
      wires: {
        byId: wiresById,
        allIds: newWireIds.filter(wireId => !wireIdsToRemove.includes(wireId))
      },
      ...newPeripherals
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/changeDoorControllerModel.js